module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "pagination": _vm.pagination,
      "response": _vm.response,
      "onEditAll": _vm.onEditAll,
      "onSearch": _vm.getRiscoLaboratorio,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "config": _vm.config,
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c410417"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/laboratorio/fator-risco/index.vue
// module id = 1427
// module chunks = 45